var map = {
	"./bear.png": "d76a",
	"./buffalo.png": "a5d4",
	"./chick.png": "3141",
	"./chicken.png": "a11d",
	"./cow.png": "67c3",
	"./crocodile.png": "1c78",
	"./dog.png": "9424",
	"./duck.png": "d089",
	"./elephant.png": "6cd4",
	"./frog.png": "f4be",
	"./giraffe.png": "5d0c",
	"./goat.png": "4067",
	"./gorilla.png": "57c9",
	"./hippo.png": "8628",
	"./horse.png": "1b18",
	"./monkey.png": "e3d2",
	"./moose.png": "7b09",
	"./narwhal.png": "c65b",
	"./owl.png": "bc5c",
	"./panda.png": "8c4d",
	"./parrot.png": "c9ab",
	"./penguin.png": "b897",
	"./pig.png": "eed4",
	"./rabbit.png": "d4e4",
	"./rhino.png": "8872",
	"./sloth.png": "4f8b",
	"./snake.png": "a80b",
	"./walrus.png": "b3c9",
	"./whale.png": "e15d",
	"./zebra.png": "166d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";